import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class IvaapAuthStateService {
  private readonly key = "ivaap_logged_in";
  private readonly timestampKey = "ivaap_login_timestamp";
  private readonly expiryMinutes = 30; // Trust login for 30 minutes

  isLoggedIn(): boolean {
    const loggedIn = localStorage.getItem(this.key) === "true";
    if (!loggedIn) return false;

    // Check if login is still fresh
    const timestamp = localStorage.getItem(this.timestampKey);
    if (!timestamp) return false;

    const loginTime = parseInt(timestamp, 10);
    const now = Date.now();
    const ageMinutes = (now - loginTime) / (1000 * 60);

    if (ageMinutes > this.expiryMinutes) {
      // Login expired, clear state
      this.markLoggedOut();
      return false;
    }

    return true;
  }

  markLoggedIn(): void {
    localStorage.setItem(this.key, "true");
    localStorage.setItem(this.timestampKey, Date.now().toString());
  }

  markLoggedOut(): void {
    localStorage.removeItem(this.key);
    localStorage.removeItem(this.timestampKey);
  }
}
